export const imgPasswordVisible = require("../assets/visible_password.svg");
export const imgPasswordInVisible = require("../assets/invisible_password.svg");
export const logo = require("../assets/logo.png");
export const loginBg = require("../assets/login-bg.svg");
export const loginLeftLogo = require("../assets/login-left-logo.svg")
export const mircosoftLogo = require("../assets/ms-ic.svg")